import { motion } from "framer-motion";
import closingVideo from "@/assets/coressen-global.mp4";


const ClosingCTA = () => {
  return (
    <section
      className="py-24 md:py-32 relative overflow-hidden"
      style={{ background: "linear-gradient(180deg, hsl(215 48% 20%), hsl(217 61% 10%))" }}
    >
      {/* Background gradient */}
      <div className="absolute inset-0">
        <div
          className="absolute top-0 right-0 w-[500px] h-[500px] rounded-full blur-3xl opacity-20"
          style={{ backgroundColor: "hsl(216 32% 52%)" }}
        />
        <div
          className="absolute bottom-0 left-0 w-[400px] h-[400px] rounded-full blur-3xl opacity-15"
          style={{ backgroundColor: "hsl(216 35% 65%)" }}
        />
      </div>

      <div className="container px-4 relative z-10">
        <div className="flex flex-col lg:flex-row items-center justify-center gap-12 lg:gap-20 max-w-6xl mx-auto">
          {/* Text content */}
          <motion.div
            initial={{ opacity: 0, x: -40 }}
            whileInView={{ opacity: 1, x: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.8 }}
            className="flex-1 text-center lg:text-left max-w-xl"
          >
            <h2 className="font-display text-3xl md:text-4xl lg:text-5xl font-bold leading-tight mb-6 text-white">
              ¿Tu negocio creció pero tu{" "}
              <span className="text-[#7ab7fd]">marca se quedó atrás?</span>
            </h2>

            <p className="text-lg md:text-xl text-white/70 leading-relaxed mb-8">
              Es hora de que tu imagen proyecte el nivel real de lo que construiste.
            </p>

            <motion.button
              onClick={() => document.getElementById("inversion")?.scrollIntoView({ behavior: "smooth" })}
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.6, delay: 0.3 }}
              className="inline-flex items-center gap-2 px-10 py-4 bg-[#7ab7fd] text-[#0a162a] font-bold text-sm tracking-[0.15em] rounded-full shadow-lg shadow-[#7ab7fd]/30 hover:shadow-[0_12px_40px_rgba(122,183,253,0.5)] hover:bg-[#93c5fd] transition-all duration-300 hover:scale-105"
            >
              APLICAR
            </motion.button>
          </motion.div>

          {/* Video */}
          <motion.div
            initial={{ opacity: 0, x: 40 }}
            whileInView={{ opacity: 1, x: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.8, delay: 0.2 }}
            className="flex-shrink-0"
          >
            <div className="relative w-[280px] md:w-[320px] aspect-[9/16] rounded-2xl overflow-hidden shadow-2xl border border-[hsl(216_32%_52%/0.4)]">
              {/* Decorative glow */}
              <div className="absolute -inset-1 bg-gradient-to-br from-[hsl(216_32%_52%/0.25)] to-transparent rounded-2xl blur-xl opacity-60" />

              <video
                src={closingVideo}
                autoPlay
                loop
                muted
                playsInline
                className="relative w-full h-full object-cover rounded-2xl"
              />
            </div>
          </motion.div>
        </div>
      </div>
    </section>
  );
};

export default ClosingCTA;
